import { render, staticRenderFns } from "./BookingRoomDailyPriceTable.vue?vue&type=template&id=30f065b0"
import script from "./BookingRoomDailyPriceTable.vue?vue&type=script&lang=js"
export * from "./BookingRoomDailyPriceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports